import React from 'react'
import { Link } from 'react-router-dom'
import cx from 'classnames'
import SideBar from '../../components/sidebar'
import UpdatePageTitle from '../../utils/common'
import './styles.css'
import articleJson from '../../assets/generated/homeArticleList.json'

const createMarkup = content => ({ __html: content })

const Home = () => {
  UpdatePageTitle('Home')
  return (
    <div className={cx('section-with-sidebar-wrapper')}>
      <section className={cx('section-with-sidebar-container')}>
        <h1 className={cx('section-header')}>Latest Mesh!</h1>
        {/* Render List of Article Cards */}
        <section className={cx('article-cards-grid')}>
          {articleJson.articleList.map(article => (
            <article className={cx('article-card')} key={article.id}>
              <Link to={article.link} className={cx('article-link')}>
                <figure className={cx('article-card-thumbnail')}>
                  <img src={require(`../../assets/images/${article.thumbnail}`)} alt='article thumbnail' />
                </figure>
                <div className={cx('article-card-content')}>
                  <h2>{article.title}</h2>
                  <p dangerouslySetInnerHTML={createMarkup(article.content)} />
                </div>
              </Link>
            </article>
          ))}
        </section>
      </section>
      <SideBar />
    </div>
  )
}

export default Home



// WEBPACK FOOTER //
// ./src/client/containers/home/index.js